import { useEffect } from "react";
import { motion } from "framer-motion";

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6 }
};

// TEAM PHOTOS - Replace the placeholder URLs with actual photo URLs after upload
const team = [
  {
    name: "Laurence Bordry",
    title: "Co-fondatrice",
    initials: "LB",
    photo: "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736923/Laurence_Bordry_frc7fa.png",
    bio: "Directrice Marketing, Digital, Communication et Innovation pendant plus de 20 ans dans de grands groupes de services (Galeries Lafayette, Accor), j'ai également accompagné des groupes immobiliers dans leurs enjeux de transformation. Parisienne des \"deux rives\", partagée entre une enfance à Saint-Germain-des-Prés et différents lieux de vie entre le 16ème et le charmant quartier des Batignolles, je connais Paris dans son âme et ses contrastes. J'ai acquis une expertise immobilière concrète à travers des projets d'optimisation des espaces et le lancement de la marque de co-working Wojo. Co-fondatrice d'Emplacement-Immo en décembre 2024, je pilote aujourd'hui le commercial, le marketing et la communication, et suis le contact privilégié de la presse et des institutionnels."
  },
  {
    name: "Marie-Caroline Nehama",
    title: "Directrice Générale",
    initials: "MCN",
    photo: "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736927/Marie-Caroline_Nehama_qivmnj.png",
    bio: "Après 20 ans d'excellence dans le trading international chez Sucres et Denrées, dont 10 ans comme Directrice du Trade, j'ai choisi de mettre mes compétences au service de vos projets immobiliers en co-fondant Emplacement-Immo. Mon parcours m'a permis de développer une expertise pointue en négociation, une capacité d'analyse approfondie des marchés, un sens aigu de l'anticipation et une excellence relationnelle avec tous types d'interlocuteurs. Je combine aujourd'hui une connaissance fine du marché immobilier parisien, des techniques de négociation éprouvées et un réseau professionnel solide, pour comprendre précisément vos besoins, optimiser votre temps et vous accompagner jusqu'à la signature finale, avec une transparence totale."
  },
  {
    name: "Dean Ackah-Miezan",
    title: "Co-fondateur",
    initials: "DAM",
    photo: "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736922/Dean_Ackah-Miezan_rldotm.png",
    bio: "Diplômé en Science Politique et en Sciences Économiques, je suis un manager et entrepreneur expérimenté, ayant évolué dans des secteurs toujours très concurrentiels.\nAprès 20 ans à la direction commerciale de grands groupes américains du Retail (Ralph Lauren, Gap), deux années en tant que chef d'entreprise indépendant, puis 6 ans aux commandes de l'opérationnel de la startup de mobilité électrique Cityscoot, j'ai forgé une solide expertise immobilière à travers de nombreux projets d'envergure.\nReconnu pour ma sensibilité humaine et mes qualités de négociateur, j'accompagne et défends les intérêts des acquéreurs avec engagement. Parisien depuis plus de 50 ans, j'ai rejoint Emplacement-Immo pour mettre cette expérience unique au service de vos projets."
  },
  {
    name: "Laurie Briche",
    title: "Architecte",
    initials: "LBr",
    photo: "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736926/Laurie_Briche_cf0jg2.png",
    bio: "Architecte diplômée, j'apporte à Emplacement-Immo une expertise rare : celle de savoir lire un bien au-delà de ce qu'il est, pour révéler tout ce qu'il pourrait devenir.\nMon œil affûté pour les volumes, la lumière et le potentiel de transformation est un atout précieux pour mes clients, qu'ils cherchent un bien clé en main ou un espace à réinventer. J'accompagne chaque projet avec exigence et créativité, pour que votre futur chez-vous soit exactement à votre image."
  },
  {
    name: "Laurent Bensimon",
    title: "Président",
    initials: "LB",
    photo: "https://res.cloudinary.com/dpeldfqpi/image/upload/v1774736925/Laurent_Bensimon_x5aip8.png",
    bio: "Parisien depuis toujours, j'ai exploré chaque recoin de la capitale : du 16ème au 9ème, en passant par les 8ème, 6ème et 7ème arrondissements. Cette connaissance intime de Paris s'est enrichie lors d'une expatriation à New York, m'offrant une perspective unique sur notre marché immobilier. Diplômé en Droit des Affaires (Paris II) et en Gestion de Patrimoine (Dauphine), j'ai bâti ma carrière dans les marchés financiers depuis 1984, avant d'étendre mon expertise à l'immobilier, particulièrement dans la restructuration de biens d'exception. En tant que Président d'Emplacement-Immo, je mets cette double expertise financière et immobilière au service des Parisiens. Notre équipe s'engage à transformer votre recherche immobilière en une expérience sereine et efficace, adaptée à votre rythme de vie exigeant."
  }
];

const values = [
  {
    title: "Sur-mesure",
    description: "Chaque projet est unique. Nous prenons soin de bien comprendre vos exigences, d'être force de proposition, de veiller à votre satisfaction et de défendre vos intérêts."
  },
  {
    title: "Transparence",
    description: "Nous vous communiquons les informations réelles — points forts comme points de vigilance — pour vous permettre de prendre vos décisions en toute connaissance de cause."
  },
  {
    title: "Expertise",
    description: "Nous mettons à votre service des compétences complémentaires forgées dans des secteurs d'excellence, une expertise approfondie du marché parisien et un réseau solide d'experts — notaires, courtiers, architectes, fiscalistes — mobilisables à chaque étape de votre projet."
  }
];

export const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="about-page" className="pt-32">
      {/* Hero */}
      <section className="py-16 md:py-24 bg-background">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-3xl mx-auto"
          >
            <p className="text-gold text-sm font-bold uppercase tracking-[0.2em] mb-4">
              Notre équipe
            </p>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-6">
              À propos d'Emplacement-immo
            </h1>
            <p className="text-text-secondary text-lg">
              Une équipe passionnée d'experts au service de vos projets immobiliers parisiens
            </p>
          </motion.div>
        </div>
      </section>

      {/* Team Section */}
      <section data-testid="team-section" className="py-16 md:py-24 bg-surface">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="space-y-16">
            {team.map((member, index) => (
              <motion.div
                key={member.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                data-testid={`team-member-${index}`}
                className={`flex flex-col ${
                  index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                } gap-8 md:gap-12 items-center`}
              >
                {/* Photo placeholder */}
                <div className="w-full md:w-1/3 flex-shrink-0">
                  <div 
                    className="aspect-[3/4] bg-surface border border-line flex items-center justify-center overflow-hidden"
                    data-testid={`team-photo-${member.name.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {member.photo ? (
                      <img 
                        src={member.photo} 
                        alt={member.name}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="text-center">
                        <span className="text-gold text-4xl font-bold block">{member.initials}</span>
                        <span className="text-text-secondary text-xs mt-2 block">Photo à uploader</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Bio */}
                <div className="flex-1">
                  <h2 className="font-serif text-3xl text-text-primary mb-2">
                    {member.name}
                  </h2>
                  <p className="text-gold font-semibold mb-6 uppercase tracking-widest text-sm">{member.title}</p>
                  <p className="text-text-secondary leading-relaxed whitespace-pre-line">
                    {member.bio}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section data-testid="values-section" className="py-16 md:py-24 bg-background">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-text-primary text-center mb-16"
          >
            Ce qui nous anime
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <motion.div
                key={value.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                data-testid={`value-${index}`}
                className="bg-white border border-line p-10 text-center shadow-sm"
              >
                <h3 className="font-serif text-text-primary text-2xl mb-4">
                  {value.title}
                </h3>
                <div className="w-12 h-px bg-gold mx-auto mb-6"></div>
                <p className="text-text-secondary leading-relaxed">
                  {value.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
